import React from 'react';
import Button from '../../shared/components/FormElements/Button';
import '../../shared/components/Popup/popup.css';
import CandidatePopupQuestionCard from '../Component/CandidatePopupQuestionCard';
import { renderSkill } from '../../shared/utils/SkillUtils';
import './CandidatePopup.css';

const CandidateQuestionsPopup = props => {
  return (
    <div className="cmn_overlay">
      <div className="cmn_popup big_popup">
        <div className="cmn_pop_head cmn_dis_flx cmn_justify_spa_bwn cmn_al_cen">
          <h2>
            {' '}
            {renderSkill({
              skillName: props.skillDetails.name,
              difficultyLevel: props.skillDetails.difficultyLevel,
            })}{' '}
            - Questions and Answers
          </h2>
        </div>
        <div className="cmn_pop_content can_rep_height">
          {props.skillDetails.answers.map((val, index) => {
            return (
              <CandidatePopupQuestionCard
                key={val.id}
                index={index}
                question={val.question}
                answer={val.answer}
                answers={val.answers}
                feedback={
                  val?.descriptiveQuestionEvaluation?.feedback
                    ? val.descriptiveQuestionEvaluation.feedback
                    : false
                }
                skillId={props.skillDetails.skillId}
                candidateReportId={props.candidateReportId}
                handleReloadSummary={props.handleReloadSummary}
              />
            );
          })}
        </div>
        <div className="cmn_pop_footer">
          <div className="cmn_form_btn_container">
            <Button
              className="cmn_btn cmn_primary_txt cmn_secondary_btn cmn_pop_close"
              onClick={() => {
                props.closePopupToggle();
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateQuestionsPopup;
